import { render } from "./quote-breakdown.vue?vue&type=template&id=98614e3a"
import script from "./quote-breakdown.vue?vue&type=script&lang=js"
export * from "./quote-breakdown.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__